import * as React from "react"
import { useContext, useState } from "react"
import Slider from "react-slick"

import { Context } from "../../store/store"
import { getText } from "../strapi"
import MafoQuestionOne from "./Mafos/MafoQuestionOne"
import MafoQuestionEight from "./Mafos/MafoQuestionEight"
import MafoQuestionFive from "./Mafos/MafoQuestionFive"
import MafoQuestionFour from "./Mafos/MafoQuestionFour"
import MafoQuestionNine from "./Mafos/MafoQuestionNine"
import MafoQuestionSeven from "./Mafos/MafoQuestionSeven"
import MafoQuestionSix from "./Mafos/MAfoQuestionSix"
import MafoQuestionTen from "./Mafos/MafoQuestionTen"
import MafoQuestionThree from "./Mafos/MafoQuestionThree"
import MafoQuestionTwo from "./Mafos/MafoQuestionTwo"
import MafoQuestionEleven from "./Mafos/MafoQuestionEleven"

interface MafoProps {
	register: Function
	errors: any
	watch: Function
	setValue: Function
}
const Mafo: React.FC<MafoProps> = ({ register, errors, watch, setValue }) => {
	const { globalState } = useContext(Context)
	const [slider, setSlider] = useState<any>(null)
	const [currentSlide, setCurrentSlide] = useState(0)
	const totalSlides = 11

	const next = () => {
		if (currentSlide < totalSlides - 1) slider?.slickNext()
	}
	const prev = () => {
		if (currentSlide > 0) slider?.slickPrev()
	}
	var settings = {
		dots: true,
		infinite: false,
		speed: 100,
		slidesToShow: 1,
		arrows: false,
		slidesToScroll: 1,
		swipeToSlide: true,
		initialSlide: 0,
		adaptiveHeight: true,
		beforeChange: (_current: number, next: number) => setCurrentSlide(next),
	}

	return (
		<div className=" pb-[32px] pt-6 sm:pb-[24px] mx-auto mb-2 sm:mb-2 md:min-w-[800px] mafo-before">
			<div className="max-w-[1324px] mx-auto">
				<h2 className="text-blue text-center mb-2 sm:mb-1 uppercase">Fast geschafft</h2>
				<p className=" max-w-[90%] md:max-w-[75%] mx-auto mt-8 text-center mb-12 md:mb-24">Zum Schluss haben wir noch einige Fragen an Dich. Die Beantwortung ist freiwillig. 
Deine Antworten werden anonym ausgewertet und helfen uns dabei, TREK weiter zu verbessern.</p>
				<Slider ref={(c: any) => setSlider(c)} {...settings} className=" w-[90%] mx-auto max-w-[calc(100vw-3rem)]">
					<div className="">
						<MafoQuestionOne {...{ register, errors, watch, setValue }} />
					</div>
					<div className="">
						<MafoQuestionTwo {...{ register, errors }} />
					</div>
					<div className="">
						<MafoQuestionThree {...{ register, errors, watch, setValue }} />
					</div>
					<div className="">
						<MafoQuestionFour {...{ register, errors, watch, setValue }} />
					</div>
					<div className="">
						<MafoQuestionFive {...{ register, errors, watch, setValue }} />
					</div>
					<div className="">
						<MafoQuestionSix {...{ register, errors, watch, setValue }} />
					</div>

					<div className="">
						<MafoQuestionSeven {...{ register, errors }} />
					</div>
					<div className="">
						<MafoQuestionEight {...{ register, errors }} />
					</div>

					<div className="">
						<MafoQuestionNine {...{ register, errors }} />
					</div>
					<div className="">
						<MafoQuestionTen {...{ register, errors }} />
					</div>
					<div className="">
						<MafoQuestionEleven {...{ register, errors }} />
					</div>
				</Slider>
				<div className="mx-auto mt-12 text-center px-6 text-[14px] lg:text-[18px] font-AmsiRegular text-black ">
					<div onClick={() => currentSlide > 0 && slider?.slickGoTo(0)} className={`inline-block mr-6 ${currentSlide === 0 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}><img src={process.env.PUBLIC_URL + "/images/double-arrow-left.svg"} alt="Icon" /></div>
					<div onClick={() => prev()} className={`inline-block mr-6 ${currentSlide === 0 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}><img src={process.env.PUBLIC_URL + "/images/arrow-left.svg"} alt="Icon" /></div>
					<span>Frage {currentSlide + 1} von 11</span>
					<div onClick={() => next()} className={`inline-block ml-6 ${currentSlide === totalSlides - 1 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}><img src={process.env.PUBLIC_URL + "/images/arrow-right.svg"} alt="Icon" /></div>
					<div onClick={() => currentSlide < totalSlides - 1 && slider?.slickGoTo(totalSlides - 1)} className={`inline-block ml-6 ${currentSlide === totalSlides - 1 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}><img src={process.env.PUBLIC_URL + "/images/double-arrow-right.svg"} alt="Icon" /></div>
				</div>
			{/*	<div className="mx-auto mt-6 text-center px-6 text-[22px] lg:text-[32px]">
					{arrowVisibilityNext && (
						<a
							className="btn"
							onClick={() => {
								next()
							}}
						>
							Weiter
						</a>
					)}
				</div>*/}
			</div>
		</div>
	)
}

export default Mafo
